export default function BackButton(props: any) {
  return (
    <svg
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 399.99 400"
      {...props}
    >
      <path
        d="M157.12 86.1V14.28a14.29 14.29 0 00-24.9-9.56L3.65 147.58a14.29 14.29 0 00-.44 18.57L131.78 323.3a14.29 14.29 0 0025.34-9v-71.2c112.87 3.67 183.29 51.9 215.04 147.14A14.28 14.28 0 00385.7 400a13.84 13.84 0 002.3-.19 14.29 14.29 0 0012-14.1C399.99 217.48 298.71 93.9 157.12 86.1z"
        fill="#f7d354"
      />
    </svg>
  );
}
